export const isValidKeyValue = (key: string, value: any): boolean => {
  const { isArray } = Array;
  const isObject = (x: object) => typeof x === "object";

  const methods = {
    columns: isArray,
    data: isArray,
    headers: isObject
  };

  return methods[key] && methods[key](value);
};
